module.exports = __webpack_public_path__ + "img/CCWO.33964ce9.jpg";